import { fleetPageRoute } from '../settings/fleetPageRoutes';
import { useRouterWithHandler, UseRouterWithHandlerReturnProps } from 'common/hooks/useRouter';
import { useMemo } from "react"
// here are the variables for the paths in the url /id/view/tab/subTab/selection
// id = machine id area`
// view = main view (ex: machine-health)
// tab = sub view (ex: overview)
// subTab = sub view of the sub view or tab (ex: sessions-over-time)
// selection = sub view of the sub view or selection (aka session id)

/** for useFleetRouter is just a pre-populated useRouterWith handler hook */
export const useFleetRouter = (extraPath?: string): UseRouterWithHandlerReturnProps => {
  return useRouterWithHandler(extraPath ? `${fleetPageRoute}/${extraPath}` : fleetPageRoute);
};

export const getURLVars = (keys?: string[]): Record<string, string[]> | undefined => {
  
  const urlVars = (window.location.search.startsWith('?') 
    ? window.location.search.slice(1) 
    : window.location.search)
  .split('&')
  .map(x => x.split('='))
  .reduce((acc, [key, val]) => ({ 
    ...acc, 
    [key]: val.split(',').map(cleanVar) 
  }), {}) as Record<string, string[]>

  if (!keys) return urlVars

  let keyVars = undefined as Record<string, string[]> | undefined

  keys.forEach(key => {
    if (urlVars[key]) keyVars = { ...(keyVars || {}), [key]: urlVars[key] }
  })

  return keyVars
}
 


export const cleanVar = (x: string) => x?.replace(/%20/g, ' ')

export const useViewSelections = (filterKeys?: string[]): Record<string, string[] | undefined> | undefined => {
  
  const [{urlVars}] = useFleetRouter()
  
  const ret = useMemo(() => Object.entries((urlVars || {})).reduce((acc, [key, value]) => {
    acc[String(key)] = String(value || '').split(',').map(cleanVar)
    return acc
  }, {} as Record<string, string[] | undefined>), [urlVars])

  let filterRet = undefined as Record<string, string[] | undefined> | undefined

  if (filterKeys) {
    filterKeys.forEach(key => {
      if (ret?.[key]) filterRet = {...(filterRet || {}), [key]: ret?.[key]}
    })  
    return filterRet
  }
  return ret

}
